
let API_BASE;
let WEBSOCK_SCHEME;
let HTTP_SCHEME;

console.log("NODE_ENV: ", process.env.NODE_ENV);

if (process.env.NODE_ENV !== "development") {
    API_BASE = "seva-vet-server-637558701449.us-central1.run.app";
    WEBSOCK_SCHEME = "wss";
    HTTP_SCHEME = "https";
} else {
    API_BASE = "localhost:8000";
    WEBSOCK_SCHEME = "ws";
    HTTP_SCHEME = "http";
}

// const API_BASE = "http://localhost:8000";

export const API_BASE_URL = `${HTTP_SCHEME}://${API_BASE}/api/v1`;
export const WEBSOCK_BASE_URL = `${WEBSOCK_SCHEME}://${API_BASE}/api/v1`;